<template>
<el-form-item :label="$t('actions.project.settings.access')" class='access-setting'>
  <el-radio-group theme='info' v-model="type">

    <el-radio-button :disabled="disabled.none" label='none'>
      <el-tooltip :disabled="!disabled.none" effect="dark" :content="disabled.msg" placement="top">
        <span>{{$t('actions.project.settings.accessTypes.none')}}</span>
      </el-tooltip>
    </el-radio-button>

    <el-radio-button :disabled="disabled.code" label='code'>
      <el-tooltip :disabled="!disabled.code" effect="dark" :content="disabled.msg" placement="top">
        <span>{{$t('actions.project.settings.accessTypes.code')}}</span>
      </el-tooltip>
    </el-radio-button>

    <!--
    <el-radio-button :disabled="disabled.pay" label='pay'>
      <el-tooltip :disabled="!disabled.pay" effect="dark" :content="disabled.msg" placement="top">
        <span>{{$t('actions.project.settings.accessTypes.pay')}}</span>
      </el-tooltip>
    </el-radio-button>

    <el-radio-button :disabled="disabled.spell" label='spell'>
      <el-tooltip :disabled="!disabled.spell" effect="dark" :content="disabled.msg" placement="top">
        <span>{{$t('actions.project.settings.accessTypes.spell')}}</span>
      </el-tooltip>
    </el-radio-button>
    -->
  </el-radio-group>

  <div class='access-content'>
    <div class='none' v-if="type === 'none'">
      <p class='hint'>{{$t('hint.project.edit.access.none')}}</p>
    </div>

    <div class='code' v-if="type === 'code'">
      <!-- <p class='hint'>{{$t('hint.project.edit.access.code')}}</p> -->
      <el-form label-position='top' class='sub-form'>
        <el-form-item :label="$t('actions.project.settings.accessLabels.code')">
          <el-input :readonly="disabled.code" :placeholder="$t('placeholder.project.auth_config.code')" v-model="config.code">
            <el-button class='random-code-btn' slot="append" @click="randomCode('code')">
              {{$t('actions.project.settings.accessLabels.random')}}
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('actions.project.settings.accessLabels.hint')">
          <el-input :readonly="disabled.code" :placeholder="$t('placeholder.project.auth_config.hint')" v-model="config.hint">
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('actions.project.settings.accessLabels.previewPages')">
          <el-input-number :disabled="disabled.code" v-model="config.preview_pages" :min="0" :max="project.total_pages"></el-input-number>
        </el-form-item>
      </el-form>
    </div>

    <div class='pay' v-if="type === 'pay'">
      <!-- <p class='hint'>{{$t('hint.project.edit.access.pay')}}</p> -->

      <el-form label-position='top' class='sub-form'>
        <el-form-item label="1">
          <span slot='label'>
                {{$t('actions.project.settings.accessLabels.price')}}
                <a target="_blank" href="https://mp.weixin.qq.com/s/cyI_HAJp0P_fXOFHxZ_cdA"><i class='ppj-icon-help-circled'></i></a>
            </span>

          <div class='el-input' style='width: 180px'>
            <vue-numeric :read-only="disabled.pay" class='el-input__inner' :precision='2' currency='￥' v-model="price" />
          </div>
        </el-form-item>

        <el-form-item :label="$t('actions.project.settings.accessLabels.previewPages')">
          <el-input-number :disabled="disabled.pay" v-model="config.preview_pages" :min="0" :max="project.total_pages"></el-input-number>
        </el-form-item>
      </el-form>
    </div>

    <div class='spell' v-if="type === 'spell'">
      <!-- <p class='hint'>{{$t('hint.project.edit.access.spell')}}</p> -->
      <el-form label-position='top' class='sub-form'>
        <el-form-item :label="$t('actions.project.settings.accessLabels.code')">
          <el-input :readonly="disabled.spell" :placeholder="$t('placeholder.project.auth_config.code')" v-model="config.code">
            <el-button class='random-code-btn' slot="append" @click="randomCode('spell')">
              {{$t('actions.project.settings.accessLabels.random')}}
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="1">
          <span slot='label'>
                {{$t('actions.project.settings.accessLabels.wechat')}}
                <a @click='wechatTips'><i class='ppj-icon-help-circled'></i></a>
            </span>
          <el-input :readonly="disabled.spell" :placeholder="$t('placeholder.project.auth_config.wechat')" v-model="config.wechat">
          </el-input>
        </el-form-item>

        <el-form-item label="1">
          <span slot='label'>
              {{$t('actions.project.settings.accessLabels.spell')}}
              <a target="_blank" href="http://mp.weixin.qq.com/s?__biz=MzAxNTc4NjY1NA==&mid=100000024&idx=1&sn=5433384086766586e47833b99260eadb&chksm=1bfff6e92c887fffad42d48ce2cc399796e31316ec85987f5d88f3692ba5e4790137ef9377be&mpshare=1&scene=23&srcid=11220bkdzdzMRr0b2hCt41Fs#rd"><i class='ppj-icon-help-circled'></i></a>
          </span>
          <el-input :readonly="disabled.spell" :placeholder="$t('placeholder.project.auth_config.spell')" v-model="config.wechat_spell">
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('actions.project.settings.accessLabels.previewPages')">
          <el-input-number :disabled="disabled.spell" v-model="config.preview_pages" :min="0" :max="project.total_pages"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
  </div>
</el-form-item>
</template>

<i18n>
{
  "zh-cn": {
    "accessDisableReasonTemp": "临时@:common.project不能设置访问限制为公众号或付费阅读",
    "accessDisableReasonOverdate": "过期@:common.project不能修改访问限制规则"
  }
}
</i18n>

<script>
import { lazyload } from '@/assets/scripts/lazy-load-module'

export default {
  data() {
    return {
      type: null,
      config: {},
      price: 0.0
    }
  },
  components: {
    'vue-numeric': () => lazyload('vue-numeric')
  },
  props: ['value', 'project'],
  computed: {
    disabled() {
      let state = this.project.permanent ? 0 : (this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000 ? 2 : 1)

      return {
        'none': state === 2,
        'code': state === 2,
        'pay': !this.project.permissions.set_special_auth_type,
        'spell': !this.project.permissions.set_special_auth_type,
        'msg': state === 0 ? '' : this.$t(state === 1 ? 'accessDisableReasonTemp' : 'accessDisableReasonOverdate')
      }
    }
  },
  watch: {
    value: function(newValue) {
      let vm = this
      vm.type = newValue.type
      vm.config = Object.assign({}, vm.config, newValue.config)
      vm.price = newValue.price || 0
    }
  },
  methods: {
    wechatTips() {
      let vm = this
      let h = vm.$createElement

      vm.$msgbox({
        message: h('img', {
          style: 'width: 80%;margin-left: 10%;',
          attrs: {
            src: '/static/images/setting-wechat-hint.png'
          }
        }),
        confirmButtonText: vm.$t('common.buttons.close')
      })
    },
    dataInit() {
      this.type = null
      this.config = {
        code: null,
        hint: null,
        wechat: null,
        wechat_spell: null,
        preview_pages: 0
      }
      this.price = 0.0
    },
    randomCode(position) {
      if (this.disabled[position]) {
        return
      }

      let possible = '0123456789'
      let value = ''

      for (var i = 0; i < 8; i++) {
        value += possible.charAt(Math.floor(Math.random() * possible.length))
      }

      this.config.code = value
    },
    save: function(e) {
      // do validation
      this.$emit('input', {
        type: this.type,
        config: this.config,
        price: this.price
      })
    }
  },
  mounted() {
    this.dataInit()
  }
}
</script>

<style lang='scss' scoped>
.access-setting {
    .hint {
        line-height: 1;
        margin-bottom: 0;
    }

    .sub-form {
        width: 80%;
    }

    .label {
        white-space: nowrap;
    }

    .random-code-btn {
        background-color: $color-white-base;
        color: $font-color-base;
    }

    .ppj-icon-help-circled {
        color: $color-info;
        margin-left: 0.2em;
        &:hover {
            color: darken($color-info, 20%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// access.card.vue?87036956